import { IAMAPI } from './API'
import {
  CreateInvitationPayload,
  AcceptInvitePayload,
} from './dtos/invitations'

export default class InvitationStore {
  constructor(private api: IAMAPI) {}

  /**
   * Gets an invite by token.
   *
   * @param {*} idOrToken
   */
  get(idOrToken: string) {
    return this.api.invitations.get(idOrToken)
  }

  /**
   * Invites a user to a workspace (and optionally a  team)
   *
   * @param {*} payload
   */
  invite(payload: CreateInvitationPayload) {
    return this.api.invitations.create(payload)
  }

  /**
   * Accepts an invitation
   *
   * @param {*} payload
   */
  accept(payload: AcceptInvitePayload) {
    return this.api.invitations.accept(payload)
  }
}
